import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="parent">
      <div id="divimg">
        {/*<img
          class="child"
          alt=""
          src={URL}/>*/}
      </div>
      <a href="https://gonetrow.goholidays.co.nz/Mango_go_ROW/#/login"><div class="link1"></div></a>
      <a href="https://gonetpac.goholidays.co.nz/Mango_Go_Pacific/#/login"><div class="link2"></div></a>
    </div>
  );
}

export default App;
